import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import { AutoComplete, Col, Form, Input, Row, Space, Tooltip } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { debounce } from "lodash";
import "../../styles/Main.scss";
// import { LoadScript } from "@react-google-maps/api";
// import Map from "./Map";
import { authUserData } from "../../utils/Helper";

const CompanyDepoAddress = ({ state, setState, companyId, data }) => {
  const { t } = useTranslation();
  const colors = ["#0000"];
  // const [apiLoading, setapiloading] = useState(false);
  // const libraries = ["places"];
  const formRef = useRef();
  const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [depo_address, setdepo_address] = useState([
  //     { depo_street_address: '', depo_suburb: '', depo_state: '', depo_postcode: '', depo_additional_details: '' },
  // ]);
  // Function to handle input changes for key person fields
  // const handleCloneInputChange = (field, e, index) => {
  //     let newPersonArr = state.depo_address;
  //     newPersonArr[index][field] = e.target.value ? e.target.value : null;
  //     setState({ ...state, depo_address: newPersonArr });
  // };

  // Function to remove a key person from the list
  // const removePerson = async (lastIndex) => {
  //     let filterPersonArr = state.depo_address.filter(
  //         (item, index) => index !== lastIndex
  //     );
  //     setState({ ...state, depo_address: filterPersonArr });
  //     setWeightSizeFieldValue(filterPersonArr);
  // };
  const removePerson = (index) => {
    // Create a new array excluding the person at the specified index
    const newdepo_address = state.depo_address.filter((_, i) => i !== index);

    // Update the state with the new depo_address array
    setState((prevState) => ({
      ...prevState,
      depo_address: newdepo_address,
    }));

    // Prepare to reset fields for all subsequent persons
    const resetFields = {};

    // Reset fields for all remaining persons after the removed index
    newdepo_address.forEach((_, i) => {
      resetFields[`depo_street_address${i}`] =
        newdepo_address[i].depo_street_address || "";
      resetFields[`depo_suburb${i}`] = newdepo_address[i].depo_suburb || "";
      resetFields[`depo_state${i}`] = newdepo_address[i].depo_state || "";
      resetFields[`depo_postcode${i}`] = newdepo_address[i].depo_postcode || "";
      resetFields[`depo_additional_details${i}`] =
        newdepo_address[i].depo_additional_details || "";
    });

    // Set form values for the remaining fields
    form.setFieldsValue(resetFields);
  };
  const handleSearch = useCallback(
    (index) =>
      debounce((value) => {
        // Implement the Google Places API logic
        const service = new window.google.maps.places.AutocompleteService();

        if (value !== "") {
          service.getPlacePredictions(
            { input: value },
            (predictions, status) => {
              if (
                status === window.google.maps.places.PlacesServiceStatus.OK &&
                predictions
              ) {
                setOptions(
                  predictions.map((prediction) => ({
                    value: prediction.description,
                    place_id: prediction.place_id,
                  }))
                );
              } else {
                setOptions([]);
              }
            }
          );
        } else {
          // Clear the corresponding address fields
          const newAddresses = [...state.depo_address];
          newAddresses[index] = {
            depo_street_address: null,
            depo_suburb: null,
            depo_state: null,
            depo_postcode: null,
            depo_additional_details: null,
            // coordinates: { latitude: null, longitude: null },
          };
          setState((prev) => ({ ...prev, depo_address: newAddresses }));
          form.setFieldsValue({
            [`depo_street_address${index}`]: null,
            [`depo_suburb${index}`]: null,
            [`depo_state${index}`]: null,
            [`depo_postcode${index}`]: null,
          });
        }
      }, 300),
    [state.depo_address, form]
  );

  // const handleSearch = useCallback(
  //     (index) => debounce((value) => {
  //         // Implement the Google Places API logic
  //         const service = new window.google.maps.places.AutocompleteService();

  //         if (value !== "") {
  //             service.getPlacePredictions({ input: value }, (predictions, status) => {
  //                 if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
  //                     setOptions(predictions.map((prediction) => ({
  //                         value: prediction.description,
  //                         place_id: prediction.place_id,
  //                     })));
  //                 } else {
  //                     setOptions([]);
  //                 }
  //             });
  //         }
  //         // else {
  //         //     // Clear the corresponding address fields
  //         //     const newAddresses = [...state.depo_address];
  //         //     newAddresses[index] = [  { depo_street_address: null, depo_suburb: null, depo_state: null, depo_postcode: null, depo_additional_details: null }]; // Reset address at this index
  //         //     setState((prev) => ({ ...prev, depo_address: [   { depo_street_address: null, depo_suburb: null, depo_state: null, depo_postcode: null, depo_additional_details: null }] }));
  //         // }
  //     }, 300),
  //     [state.depo_street_address]
  // );

  // const handleSelect = (index) => (value) => {
  //     const selected = options.find((option) => option.value === value);
  //     if (selected && selected.place_id) {
  //         const service = new window.google.maps.places.PlacesService(document.createElement("div"));
  //         service.getDetails({ placeId: selected.place_id }, (place, status) => {
  //             if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
  //                 const newAddresses = [...state.depo_address];
  //                 newAddresses[index] = {
  //                     depo_street_address: place.formatted_address,
  //                     depo_suburb: place.address_components.find((ac) => ac.types.includes("locality"))?.long_name || "",
  //                     depo_state: place.address_components.find((ac) => ac.types.includes("administrative_area_level_1"))?.short_name || "",
  //                     depo_postcode: place.address_components.find((ac) => ac.types.includes("postal_code"))?.long_name || "",
  //                 };
  //                 setState((prev) => ({ ...prev, depo_address: newAddresses }));
  //                 form.setFieldsValue({
  //                     [`depo_street_address${index}`]: place.formatted_address,
  //                     [`depo_suburb${index}`]: newAddresses[index].depo_suburb,
  //                     [`depo_state${index}`]: newAddresses[index].depo_state,
  //                     [`depo_postcode${index}`]: newAddresses[index].depo_postcode,
  //                 });
  //             }
  //         });
  //     }
  // };

  // Function to set the values of the form fields based on the depo_address data

  const handleSelect = (index) => (value) => {
    if (!value) {
      // Clear the corresponding address fields
      const newAddresses = [...state.depo_address];
      newAddresses[index] = {
        depo_street_address: null,
        depo_suburb: null,
        depo_state: null,
        depo_postcode: null,
        depo_additional_details: null,
        // coordinates: { latitude: null, longitude: null },
      };
      setState((prev) => ({ ...prev, depo_address: newAddresses }));
      form.setFieldsValue({
        [`depo_street_address${index}`]: null,
        [`depo_suburb${index}`]: null,
        [`depo_state${index}`]: null,
        [`depo_postcode${index}`]: null,
      });
      return;
    }

    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          const newAddresses = [...state.depo_address];
          newAddresses[index] = {
            depo_street_address: place.formatted_address,
            depo_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            depo_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            depo_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
            // coordinates: {
            //   latitude: place.geometry?.location?.lat() || null,
            //   longitude: place.geometry?.location?.lng() || null,
            // },
          };
          setState((prev) => ({ ...prev, depo_address: newAddresses }));
          form.setFieldsValue({
            [`depo_street_address${index}`]: place.formatted_address,
            [`depo_suburb${index}`]: newAddresses[index].depo_suburb,
            [`depo_state${index}`]: newAddresses[index].depo_state,
            [`depo_postcode${index}`]: newAddresses[index].depo_postcode,
          });
        }
      });
    }
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["depo_street_address" + objectKey] =
        objectValue.depo_street_address;
      fieldObject["depo_suburb" + objectKey] = objectValue.depo_suburb;
      fieldObject["depo_state" + objectKey] = objectValue.depo_state;
      fieldObject["depo_postcode" + objectKey] = objectValue.depo_postcode;
      fieldObject["depo_additional_details" + objectKey] =
        objectValue.depo_additional_details;

      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  // Function to add a new key person to the list
  // const addPerson = () => {
  //     let newPersonArr = [
  //         ...state.depo_address,
  //         {
  //             street_address: null,
  //             suburb: null,
  //             state: null,
  //             postcode: null,
  //             additional_details: null,
  //         },
  //     ];
  //     setState({ ...state, depo_address: newPersonArr });
  //     setWeightSizeFieldValue(newPersonArr);
  // };
  const addPerson = () => {
    const newPerson = {
      depo_street_address: "",
      depo_suburb: "",
      depo_state: "",
      depo_postcode: "",
      depo_additional_details: "",
    };

    // Update the state with the new key person
    setState((prevState) => {
      const updateddepo_address = [...prevState.depo_address, newPerson];

      // Prepare to set form fields for the new person
      const newIndex = updateddepo_address.length - 1; // Get the index of the new person
      const resetFields = {
        [`depo_street_address${newIndex}`]: "",
        [`depo_suburb${newIndex}`]: "",
        [`depo_state${newIndex}`]: "",
        [`depo_postcode${newIndex}`]: "",
        [`depo_additional_details${newIndex}`]: "",
      };

      // Set form fields to empty for the new person
      form.setFieldsValue(resetFields);

      // Return the updated state
      return {
        ...prevState,
        depo_address: updateddepo_address,
      };
    });
  };

  // Function to handle phone number input changes for key persons
  // const handleClonePhoneInputChange = (field, phone, index) => {
  //     let newPersonArr = state.depo_address;
  //     newPersonArr[index][field] = phone ? phone : null;
  //     setState({ ...state, depo_address: newPersonArr });
  // };

  // useEffect hook to update form fields when the component mounts or when state, companyId, or t changes
  useEffect(() => {
    //if (companyId) {
    const modifiedInquiry = state.depo_address.map((inquiryDetail) => {
      const { id, company, company_name, ...rest } = inquiryDetail;
      return rest;
    });

    setWeightSizeFieldValue(modifiedInquiry);
    //}
  }, [state, companyId, t]);

  return (
    // <LoadScript
    //     googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
    //     libraries={libraries}
    // >

    <Form onFinish={""} autoComplete="off" form={form} ref={formRef}>
      {state.depo_address &&
        state.depo_address.map((x, index) => {
          return (
            <>
              <Row gutter={10} key={index} className="customcol">
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="street_address"
                    name={`depo_street_address` + index}
                    label={t("label_depo_address")}
                  >
                    <AutoComplete
                      id="depo_street_address"
                      placeholder={t("search_depo_address")}
                      options={options}
                      onSearch={handleSearch(index)} // Pass index to handleSearch
                      onSelect={handleSelect(index)} // Pass index to handleSelect
                      value={state.depo_address[index].depo_street_address}
                      onChange={(value) => {
                        const newdepo_address = [...state.depo_address];
                        newdepo_address[index].depo_street_address = value;
                        setState({ ...state, depo_address: newdepo_address });
                        form.setFieldsValue({
                          [`depo_street_address${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="additional_details"
                    name={`depo_additional_details` + index}
                    label={t("additional_details")}
                  >
                    <Input
                      placeholder={t("enter_additional_details")}
                      // name="additional_details"
                      value={state.depo_address[index].depo_additional_details}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newdepo_address = [...state.depo_address];
                        newdepo_address[index].depo_additional_details = value;
                        setState({ ...state, depo_address: newdepo_address });
                        form.setFieldsValue({
                          [`depo_additional_details${index}`]: value,
                        });
                      }}
                      // Adjust the number of rows as needed
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="suburb"
                    name={`depo_suburb` + index}
                    label={t("Suburb")}
                  >
                    <Input
                      placeholder={t("Suburb")}
                      // name="suburb"
                      value={state.depo_address[index].depo_suburb}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newdepo_address = [...state.depo_address];
                        newdepo_address[index].depo_suburb = value;
                        setState({ ...state, depo_address: newdepo_address });
                        form.setFieldsValue({
                          [`depo_suburb${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="state"
                    name={`depo_state` + index}
                    label={t("State")}
                  >
                    <Input
                      placeholder={t("State")}
                      // name="state"
                      value={state.depo_address[index].depo_state}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newdepo_address = [...state.depo_address];
                        newdepo_address[index].depo_state = value;
                        setState({ ...state, depo_address: newdepo_address });
                        form.setFieldsValue({
                          [`depo_state${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="postcode"
                    name={`depo_postcode` + index}
                    label={t("Postcode")}
                  >
                    <Input
                      placeholder={t("Postcode")}
                      // name="postcode"
                      value={state.depo_address[index].depo_postcode}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newdepo_address = [...state.depo_address];
                        newdepo_address[index].depo_postcode = value;
                        setState({ ...state, depo_address: newdepo_address });
                        form.setFieldsValue({
                          [`depo_postcode${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <div
                    className="addwrp"
                    style={{ margin: 0, marginTop: "22px" }}
                  >
                    <Space>
                      {index !== 0 ? (
                        // <Tooltip
                        //   color={colors}
                        //   title={
                        //     <span style={{ color: "#000000" }}>
                        //       Remove Depo Address
                        //     </span>
                        //   }
                        // >
                        <>
                          {authUserData()?.permission.includes(
                            "company|delete_depoaddress"
                          ) && (
                            <MinusSquareFilled
                              className="add"
                              onClick={() => removePerson(index)}
                            />
                          )}
                          </>
                        // </Tooltip>
                      ) : (
                        ""
                      )}
                      {/* <Tooltip
                        color={colors}
                        title={
                          <span style={{ color: "#000000", mar: "20px" }}>
                            Add Depo Address
                          </span>
                        }
                      > */}
                        {authUserData()?.permission.includes(
                          "company|add_depoaddress"
                        ) && (
                          <PlusSquareFilled
                            className="add"
                            onClick={(e) => addPerson(e)}
                          />
                        )}
                      {/* </Tooltip> */}
                    </Space>
                  </div>
                </Col>
              </Row>
            </>
          );
        })}
    </Form>

    // </LoadScript>
  );
};
CompanyDepoAddress.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func,
  companyId: PropTypes.number,
  data: PropTypes.func,
};
export default CompanyDepoAddress;
